module.exports = "/images/case_icon.png?6d5156af0aa920e6afed66a80a590f8e";